export default __webpack_public_path__ + "static/media/directory_tile.45fab5e4.png";